import DataLayerEnum from '../enumerators/data-layer.enum'
import ListEnum from '../enumerators/list.enum'

export default class DataLayerAction {
    constructor() {
        DataLayerAction.dataLayerSelectItem()
        DataLayerAction.dataLayerListItems()
        DataLayerAction.dataLayerTriggerPagination() //Reload dataLayerListItems when pagination action
    }

    static getDataLayerItem(item) {
        return {
            item_id: item.attr(DataLayerEnum.WPET_OFFER_ID_SIT),
            item_name: item.attr(DataLayerEnum.WPET_OFFER_TITLE).trim(),
            item_brand: item.attr(DataLayerEnum.WPET_OFFER_LOCATION),
            index: 0,
            item_category: item.attr(DataLayerEnum.WPET_OFFER_FLUX),
        }
    }

    static getDataLayerListInfos() {
        return {
            item_list_id: $(ListEnum.LIST_BLOCK).attr(DataLayerEnum.WPET_LIST_ID),
            item_list_name: $(DataLayerEnum.WPET_LIST_NAME).text().trim(),
        }
    }

    static dataLayerSelectItem() {
        $(DataLayerEnum.WPET_OFFER_CARD).on('click', function () {
            const listInfos = DataLayerAction.getDataLayerListInfos()
            const items = DataLayerAction.getDataLayerItem($(this))

            dataLayer.push({
                // eslint-disable-line
                event: 'select_item',
                ...listInfos,
                items,
            })
        })
    }

    static dataLayerListItems() {
        if ($(ListEnum.LIST_BLOCK).length > 0) {
            const listInfos = DataLayerAction.getDataLayerListInfos()
            const items = []

            $(DataLayerEnum.WPET_OFFER_CARD).each(function () {
                items.push(DataLayerAction.getDataLayerItem($(this)))
            })

            dataLayer.push({
                // eslint-disable-line
                event: 'view_item_list',
                ...listInfos,
                items,
            })
        }
    }

    static dataLayerTriggerPagination() {
        $(document).on('wp-etourisme-v3/list/update', (target, query) => {
            if (query.action === 'pagination') {
                DataLayerAction.dataLayerListItems()
            }
        })
    }
}
